import React, { FC, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { addressService, rpcQueryService } from "../../store/actions";
import useCommon from "../../common/hooks/useCommon";
import TransactionAccountList from "../common/transaction-account-list";
import InternalTransactionAccountList from "../common/internal-transaction-account-list";
import XRC720TokenTransferList from "../common/xrc20-token-transfer-list";

import {
  baseUnit,
  centerTruncate,
  formatNumber,
  formatUnit,
  getFiat,
  getTimeLang,
  toNumber,
  toXDCNumber,
} from "../../common/utils/function";
import { useSelector } from "react-redux";
import ContractDetails from "../common/contract-details";
import XRC721TokenTransferList from "../common/xrc721-token-transfer-list";
import XRC720HoldingList from "../common/xrc720-holding-list";
import XRC721InventoryList from "../common/xrc721-inventory-list";
import RewardList from "../common/reward-list";
import BCopy from "../../components/b-copy";
import BQR from "../../components/b-qr";
import AccountTransaction from "./common/account-transaction";
import BTooltip from "../../components/b-tooltip";
import BIdenticons from "../../components/b-identicon";
import AnalyticsList from "./common/analytics-list";
import MultichainPortfolioList from "./common/multichain-portfolio-list";
import Ads from "../common/ads";
import { useTranslation } from "react-i18next";
import { addressService1 } from "../../store/actions/index1";
import BAvatar from "../common/b-avatar";
import { CONSTANT } from "../../common/utils/constants";
import TokenImage from "../common/token-image";
import { Dropdown } from "react-bootstrap";
import { getRpcBalance } from "../../common/hooks/checkBalance";

interface TransactionListData {
  address: string;
  coin_balance: string;
  fiat_value: string;
  created_at: string;
  incount: string;
  modify_at: string;
  outcount: string;
  transaction_count: string;
  creator_address_hash: string;
  creation_tx_hash: string;
  token: any;
  hash: string;
  is_contract: any;
  is_verified: any;
  has_beacon_chain_withdrawals: boolean;
  has_custom_methods_read: boolean;
  has_custom_methods_write: boolean;
  has_decompiled_code: boolean;
  has_logs: boolean;
  has_methods_read: boolean;
  has_methods_read_proxy: boolean;
  has_methods_write: boolean;
  has_methods_write_proxy: boolean;
  has_token_transfers: boolean;
  has_tokens: boolean;
  has_validated_blocks: boolean;
  implementation_address: any;
  transaction_types: any;
  name: string;
}

const AccountDetails: FC = () => {
  const location = useLocation();
  const hashSplit = location.hash.split("#");
  const { address } = useParams();
  const _tokenType = useSelector((e: Object) => (e as any)?.common?.tokenType);
  const _fiat = useSelector((e: Object) => (e as any)?.common?.fiat);
  const _stats = useSelector((e: Object) => (e as any)?.common?.stats);
  const { getXDC, get0x } = useCommon();
  const [tab, setTab] = useState(hashSplit?.[1] ?? "");
  const [loading, setLoading] = useState(true);
  const [latestTxn, setLatestTxn] = useState<any>(null);
  const { t, i18n } = useTranslation();
  const [totalValueselectedcount, settotalValueselectedcount] =
    useState<any>(0);
  const [stats1, setStats1] = useState<any>({});
  const [stats, setStats] = useState<TransactionListData>({
    address: "",
    coin_balance: "",
    fiat_value: "",
    created_at: "",
    incount: "0",
    is_contract: false,
    is_verified: false,
    modify_at: "",
    outcount: "0",
    transaction_count: "0",
    creator_address_hash: "",
    creation_tx_hash: "",
    token: {},
    hash: "",
    has_beacon_chain_withdrawals: false,
    has_custom_methods_read: false,
    has_custom_methods_write: false,
    has_decompiled_code: false,
    has_logs: false,
    has_methods_read: false,
    has_methods_read_proxy: false,
    has_methods_write: false,
    has_methods_write_proxy: false,
    has_token_transfers: false,
    has_tokens: false,
    has_validated_blocks: false,
    implementation_address: "",
    transaction_types: [],
    name: "",
  });

  const [rpcBalance, setRpcBalance] = useState<string>("");
  const getBalance = async () => {
    if (!address) {
      setRpcBalance("0");
      return;
    }

    try {
      const balance = await getRpcBalance(get0x(address));
      console.log(balance);
 
      setRpcBalance(String(balance ?? "0"));
    } catch (err) {
      console.log(err);
      setRpcBalance("0");
    }
  };
  const handleTab = (e: string) => {
    setTab(e);
    if (!!e?.length) window.location.hash = `#${e}`;
    else {
      window.location.hash = "";
      // @ts-ignore
      window.history.replaceState(null, null, " ");
    }
  };

  const getAddress = async () => {
    try {
      setLoading(true);
      addressService
        .getAddress(address)
        .then((response) => {
          setStats(response);
          setLoading(false);
        })
        .catch((e) => setLoading(false));
      if (CONSTANT.IS_ONE) {
        addressService1
          .getAddress(address)
          .then((response) => {
            setStats1(response);
          })
          .catch((e) => setLoading(false));
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getAddress();
    getBalance();
    const validTabs = [
      "",
      "internaltx",
      "tokentxns",
      "nfttransfers",
      "balances",
      "inventory",
      "events",
      "rewards",
      "code",
      "readContract",
      "readProxyContract",
      "writeContract",
      "writeProxyContract",
      "aiAuditAnalysis",
      "analytics",
      "multichain-portfolio",
    ];
    if (!validTabs.includes(tab)) {
      setTab("");
      window.location.hash = "";
    }
  }, [address, tab]);
  const { balance, hasBalanceMismatch,rawBalance } = useMemo(() => {
    let balanceValue;
    let mismatch = false;
  
    if (rpcBalance === "0" && stats?.coin_balance === "0") {
      balanceValue = stats?.coin_balance ?? 1;
    } else if (rpcBalance !== "0" && rpcBalance !== stats?.coin_balance) {
      balanceValue = rpcBalance ?? 1;
      mismatch = true;
    } else {
      balanceValue = stats?.coin_balance ?? 1;
    }
  
    return {
      balance: formatUnit(formatNumber(toNumber(balanceValue).toString().substring(0, 12))),
      hasBalanceMismatch: mismatch,
      rawBalance: toNumber(balanceValue)
    };
  }, [rpcBalance, stats?.coin_balance]);
 

  useEffect(() => {
    if (hasBalanceMismatch) {
      rpcQueryService.sendFlag(address, rpcBalance, stats)
        .then(response => {
          console.log("Flag sent successfully:", response);
        })
        .catch(error => {
          console.error("Error sending flag:", error);
        });
    }
  }, [hasBalanceMismatch, address, rpcBalance, stats]);
  

  return (
    <div className="py-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="bs-page-title">
              <figure className="bs-icon-avatar me-2">
                <div className="mx-auto">
                  <BIdenticons
                    seed={getXDC(address)}
                    size={8}
                    scale={3}
                    color=" #3498db"
                    bgColor="#d35400"
                  />
                </div>
              </figure>
              {t("Address")}
              <span className="bs-page-title-secondary">
                #{getXDC(address)} <BCopy value={getXDC(address)} />{" "}
                <BQR value={getXDC(address)} />
              </span>
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-2">
          <div className="d-flex flex-wrap align-items-center gap-1"></div>
          <div className="d-flex align-items-center gap-1">
            <Dropdown className="d-flex bs_token-social" align="end">
              <Dropdown.Toggle
                id="dropdown-button-dark-example1"
                variant="white"
                size="sm"
              >
                <i className="bi bi-list-check"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu
                variant="dark"
                align="start"
                className="custom-menu"
              >
                <Dropdown.Item href="#" className="bs-small-font">
                  <i className="bi bi-file-earmark-check-fill me-2"></i> Token
                  Approvals Beta
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  href="#"
                  className="bs-small-font"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-check2-all me-2"></i> Validate Account
                  Balance
                </Dropdown.Item>
                <Dropdown.Item
                  href={`/balancecheck-tool?a=${address}`}
                  className="bs-small-font"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-clock-history me-2"></i> Check Previous
                  Balance
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  href="https://github.com/OpenScanAI/assets?tab=readme-ov-file#token-information-requirements"
                  className="bs-small-font"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-person-dash-fill me-2"></i> Update Name
                  Tag or Label
                </Dropdown.Item>
                <Dropdown.Item
                  href="https://github.com/OpenScanAI/assets?tab=readme-ov-file#adding-a-new-account-tag"
                  className="bs-small-font"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-flag me-2"></i> Report/Flag Address
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-lg-4">
            <div className="bs-card h-100">
              <div className="bs-card-body p-3">
                <div className="d-flex align-items-center justify-content-between pb-2">
                  <h2 className="bs-card-header-title">{t("Overview")}</h2>
                </div>

                <div className="py-2">
                  <h2 className="text-secondary mb-0">
                    {process.env.REACT_APP_BASE_UNIT} {t("Balance")}
                  </h2>
                  <div className="d-flex align-items-center">
                    <BAvatar className="me-2" />
                    <span>
                      {CONSTANT.IS_ONE && "Shard 0:"}{" "}
                      
                      {balance}
                    </span>
                  </div>
                  {CONSTANT.IS_ONE && (
                    <div className="d-flex align-items-center">
                      <BAvatar className="me-2" />
                      <span>
                        Shard 1:{" "}
                 {balance}
                      </span>
                    </div>
                  )}
                </div>
                <div className="py-2">
                  <h2 className="text-secondary mb-0">
                    {process.env.REACT_APP_BASE_UNIT} {t("Value")}
                  </h2>
                  <span>
                    {CONSTANT.IS_ONE && "Shard 0:"}{" "}
                   {getFiat(rawBalance * Number(_stats?.coin_price), 0,_fiat,true)}
                    &nbsp;@({getFiat(_stats?.coin_price, 5)}/{baseUnit()})
                  </span>
                  <br /> 
                  {CONSTANT.IS_ONE && (
                    <span>
                      Shard 1:{" "}
                   {getFiat(rawBalance * Number(_stats?.coin_price), 0,_fiat,true)}
                      &nbsp;@({getFiat(stats1?.coin_price, 5)}/{baseUnit()})
                    </span>
                  )}
                </div>
                {!!stats?.implementation_address?.length && (
                  <div className="py-2">
                    <h2 className="text-secondary mb-0">Implementation</h2>
                    <span>
                      <BTooltip text={stats?.implementation_address}>
                        <Link
                          to={`/address/${get0x(
                            stats?.implementation_address
                          )}`}
                        >
                          {centerTruncate(stats?.implementation_address)}
                        </Link>
                        <BCopy
                          value={stats?.implementation_address}
                          tooltip="Logdata to clicpboard"
                        />
                      </BTooltip>
                    </span>
                  </div>
                )}
                {stats?.has_tokens && (
                  <div className="py-2">
                    <h2 className="text-secondary mb-0">Token Holdings</h2>
                    <span>
                      <AccountTransaction hasTokens={stats?.has_tokens} />
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bs-card h-100">
              <div className="bs-card-body p-3">
                <div className="d-flex align-items-center justify-content-between pb-2">
                  <h2 className="bs-card-header-title">{t("More Info")}</h2>
                </div>
                <div className="py-2">
                  <h2 className="text-secondary mb-0">
                    {t("Public Name Tags")}
                  </h2>
                  <span>{stats.name || "-"}</span>
                  {/* <button
                                        type="button"
                                        className="btn btn-outline-secondary add-btn border-dashed"
                                    >
                                        +{t("Add")}
                                    </button> */}
                </div>

                {!stats?.token && (
                  <React.Fragment>
                    <h2 className="text-secondary mb-0">
                      {t("Transactions Sent")}
                    </h2>
                    <div className="d-flex align-items-center flex-wrap gap-1">
                      {latestTxn?.lastTxn?.hash ? (
                        <React.Fragment>
                          <span className="text-muted">Latest:</span>
                          <Link to={`/tx/${get0x(latestTxn.lastTxn.hash)}`}>
                            <span>
                              {getTimeLang(latestTxn.lastTxn.timestamp, t)}
                            </span>
                            <i className="bi bi-arrow-up-right"></i>
                          </Link>
                        </React.Fragment>
                      ) : (
                        " - "
                      )}

                      <span className="mx-1"></span>

                      {latestTxn?.firstTxn?.hash ? (
                        <React.Fragment>
                          <span className="text-muted">First:</span>
                          <Link to={`/tx/${get0x(latestTxn.firstTxn.hash)}`}>
                            <span>
                              {getTimeLang(latestTxn.firstTxn.timestamp, t)}
                            </span>
                            <i className="bi bi-arrow-up-right"></i>
                          </Link>
                        </React.Fragment>
                      ) : (
                        " - "
                      )}
                    </div>
                  </React.Fragment>
                )}

                {stats?.creator_address_hash && (
                  <div className="py-2">
                    <h2 className="text-secondary mb-0">Funded By</h2>
                    <span>
                      <Link
                        to={`/address/${get0x(stats?.creator_address_hash)}`}
                      >
                        {centerTruncate(getXDC(stats?.creator_address_hash))}
                      </Link>{" "}
                      <BCopy value={get0x(stats?.creator_address_hash)} />
                      &nbsp;at txn{" "}
                      <Link to={`/tx/${get0x(stats?.creation_tx_hash)}`}>
                        {centerTruncate(getXDC(stats?.creation_tx_hash))}
                      </Link>
                    </span>
                  </div>
                )}
                {!!stats?.token && (
                  <div className="py-2">
                    <h2 className="text-secondary mb-0">Token Tracker</h2>
                    <span>
                      <Link to={`/token/${get0x(stats?.hash)}`}>
                        <TokenImage
                          image={stats?.token?.icon_url}
                          symbol={stats?.token?.symbol}
                          params={{ width: 20, className: "me-1" }}
                        />
                        {stats?.token?.name} ({stats?.token?.symbol})
                      </Link>
                      <span className="ms-2">
                        (@${" "}
                        {formatNumber(
                          stats?.token?.fiat_value ??
                            stats?.token?.exchange_rate ??
                            "-",
                          6
                        ) === "NaN"
                          ? "0"
                          : formatNumber(
                              stats?.token?.fiat_value ??
                                stats?.token?.exchange_rate ??
                                "-",
                              6
                            )}
                        )
                      </span>
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bs-card h-100">
              <div className="bs-card-body p-3">
                <div className="d-flex align-items-center justify-content-between pb-2">
                  <h2 className="bs-card-header-title">
                    {t("Multichain Info")}
                  </h2>
                </div>
                <div
                  className="py-2"
                  onClick={() => handleTab("multichain-portfolio")}
                >
                  <span className="bs-badge h-gray py-2">{`${
                    totalValueselectedcount
                      ? getFiat(totalValueselectedcount, 2)
                      : "$0"
                  } (${t("Multichain Portfolio")})`}</span>
                </div>
                <div className="advertise-block pt-3">
                  <Ads />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-12 py-2">
            <span>
              Download <Link to={`/exportData?address=${getXDC(address)}`}>CSV Export</Link>
            </span>
          </div> */}
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="bs-tab">
              <button
                className={`bs-tab-item ${[""].includes(tab) ? "active" : ""}`}
                onClick={() => handleTab("")}
              >
                {t("Transactions")}
              </button>
              <button
                className={`bs-tab-item ${
                  ["internaltx"].includes(tab) ? "active" : ""
                }`}
                onClick={() => handleTab("internaltx")}
              >
                {t("Internal Transactions")}
              </button>
              <button
                className={`bs-tab-item ${
                  ["tokentxns"].includes(tab) ? "active" : ""
                }`}
                onClick={() => handleTab("tokentxns")}
              >
                {t("Token Transfers")} ({_tokenType}-20)
              </button>
              {stats?.has_token_transfers && (
                <button
                  className={`bs-tab-item ${
                    ["nfttransfers"].includes(tab) ? "active" : ""
                  }`}
                  onClick={() => handleTab("nfttransfers")}
                >
                  {/* Transfers ({_tokenType}-721) */}
                  {t("NFT Transfers")}
                </button>
              )}
              {stats?.has_token_transfers && (
                <button
                  className={`bs-tab-item ${
                    ["balances"].includes(tab) ? "active" : ""
                  }`}
                  onClick={() => handleTab("balances")}
                >
                  {t("Token Holding")} ({_tokenType}-20)
                </button>
              )}
              {stats?.has_token_transfers && (
                <button
                  className={`bs-tab-item ${
                    ["inventory"].includes(tab) ? "active" : ""
                  }`}
                  onClick={() => handleTab("inventory")}
                >
                  {t("Token Inventory")} ({_tokenType}-721)
                </button>
              )}
              {/* <button
                                className={`bs-tab-item ${["events"].includes(tab) ? "active" : ""
                                }`}
                                onClick={() => handleTab("events")}
                            >
                                {t("Events")}
                            </button> */}
              {process.env.REACT_APP_BASE_UNIT === "XDC" && (
                <button
                  className={`bs-tab-item ${
                    ["rewards"].includes(tab) ? "active" : ""
                  }`}
                  onClick={() => handleTab("rewards")}
                >
                  {t("Rewards")}
                </button>
              )}
              {stats?.is_contract && (
                <button
                  className={`bs-tab-item ${
                    [
                      "code",
                      "readContract",
                      "readProxyContract",
                      "writeContract",
                      "writeProxyContract",
                      "aiAuditAnalysis",
                    ].includes(tab)
                      ? "active"
                      : ""
                  }`}
                  onClick={() => handleTab("code")}
                >
                  {t("Contract")}
                  {stats?.is_verified && (
                    <i className="fa fa-check-circle bs_verified bs_verified-contract"></i>
                  )}
                </button>
              )}
              <button
                className={`bs-tab-item ${
                  ["analytics"].includes(tab) ? "active" : ""
                }`}
                onClick={() => handleTab("analytics")}
              >
                {t("Analytics")}
              </button>
              <button
                className={`bs-tab-item ${
                  ["multichain-portfolio"].includes(tab) ? "active" : ""
                }`}
                onClick={() => handleTab("multichain-portfolio")}
              >
                {t("Multichain Portfolio")}
              </button>
            </div>
            <div className="bs-tab-content">
              {[""].includes(tab) && (
                <TransactionAccountList
                  count={5}
                  transactionData={(data: any) => setLatestTxn(data)}
                />
              )}
              {["internaltx"].includes(tab) && (
                <InternalTransactionAccountList count={5} />
              )}
              {["tokentxns"].includes(tab) && (
                <XRC720TokenTransferList count={5} />
              )}
              {["nfttransfers"].includes(tab) && (
                <XRC721TokenTransferList count={5} />
              )}
              {["balances"].includes(tab) && <XRC720HoldingList count={10} />}
              {["inventory"].includes(tab) && <XRC721InventoryList />}
              {/* {["events"].includes(tab) && <EventsList/>} */}
              {["rewards"].includes(tab) && <RewardList />}
              {[
                "code",
                "readContract",
                "readProxyContract",
                "writeContract",
                "writeProxyContract",
                "aiAuditAnalysis",
              ].includes(tab) && <ContractDetails data={stats} />}
              {["analytics"].includes(tab) && <AnalyticsList />}
              {["multichain-portfolio"].includes(tab) && (
                <MultichainPortfolioList
                  getTotalValue={(value: any) =>
                    settotalValueselectedcount(value)
                  }
                />
              )}
            </div>
          </div>
        </div>
        <div className="py-2">
          <span>
            {t("Download")}{" "}
            <Link to={`/exportData?address=${getXDC(address)}`}>
              {t("CSV Export")}
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
